import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTag = ({ number, label, dark = false }) => (
  <div className="flex items-center gap-3 mb-6">
    <span className={`font-heading text-sm tracking-[0.2em] ${dark ? "text-red-500" : "text-red-700"}`}>
      {number}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-zinc-700" : "bg-zinc-300"}`} />
    <span className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-zinc-400" : "text-zinc-500"}`}>
      {label}
    </span>
  </div>
);
